export const formatSupportTicketNumber = (id: number): string => {
  const response = id.toString();
  const length = response.length;

  if (length >= 5) {
    return response;
  }
  const zeros = Array.from({ length: 5 - length }).map(() => "0").join("");

  return `#${zeros}${response}`;
};
